import type { Release } from '../releases';

export default {
  id: '2026-11-03-report-photo-snapshot',
  at: '2026-11-03T17:40:42Z',
  title: 'Вызов на скрытые работы получает проверенные фото отчёта',
  modules: ['site', 'supervision'],
  items: [
    'Фото выбранной работы добавляются в вызов из того снимка отчёта, который проверен при создании вызова, даже если автор одновременно возвращает отчёт на правку.',
    'После создания вызова автор продолжает исправление возвращённого отчёта.',
  ],
  why: 'При одновременной правке в вызов могли попадать новые фото из ещё не проверенного черновика.',
  link: '/supervision',
} satisfies Release;
